import { AreaResource, AreaType } from "../../area.resource";

export class AreaUbiquityResource extends AreaResource {
    public static readonly TYPE = AreaType.ubiquity;

    cm_riferimento:any;
    notes: string;
    constructor() {
        super(AreaUbiquityResource.TYPE);
    }
}